export default function setUpDocument() {
	document.addEventListener("contextmenu", (e) => {
		e.preventDefault();
	});
}
